import React, { useEffect } from 'react';
import { Dimensions, View } from 'react-native';
import localforage from 'localforage';
import { Text } from '@/components/Text';
import { useDialog } from '@/hooks/useDialog';
import ConfettiCannon from 'react-native-confetti-cannon';
import { logError } from '@/utils/logHandling';
import { IS_WEB } from '@/utils/platform';
import { useStoreState } from '@/stores/store';
import constants, { isPatientApp } from '@/config/constants';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { styles } from '@/components/NewUIFeatureModal/styles';

const persistSeen = async () => {
  if (IS_WEB) {
    await localforage.setItem('hasSeenNewTemplateModal', 'true');
  } else {
    await AsyncStorage.setItem('hasSeenNewTemplateModal', 'true');
  }
};

export const NewUIFeatureModal: React.FC = () => {
  const { width, height } = Dimensions.get('window');
  const { isTherapistDemo } = useStoreState((state) => state);
  const { showDialog, removeDialog } = useDialog();

  useEffect(() => {
    const isDemoStart =
      IS_WEB &&
      new URLSearchParams(window.location.search).get('demoStarten') === 'true';
    if (
      isPatientApp ||
      constants.appVersion !== '1.10.29' ||
      isTherapistDemo ||
      isDemoStart
    ) {
      return;
    }

    const showIfUnseen = async () => {
      try {
        const hasSeenInStorage = IS_WEB
          ? ((await localforage.getItem('hasSeenNewTemplateModal')) as string)
          : await AsyncStorage.getItem('hasSeenNewTemplateModal');
        const hasSeen = hasSeenInStorage ? JSON.parse(hasSeenInStorage) : false;
        if (hasSeen) {
          return;
        }
        await persistSeen();

        showDialog({
          title: '🎉 Die Bibliothek ist da!',
          confirmAction: {
            label: 'Ok',
            onPress: () => removeDialog(),
          },
          contentComponent: () => (
            <View style={styles.modalContent}>
              <View
                pointerEvents="none"
                style={{
                  position: 'absolute',
                  top: -300,
                  left: IS_WEB ? -(width * 0.22) : -180,
                  width,
                  height,
                }}
              >
                <ConfettiCannon
                  count={200}
                  origin={{ x: 0, y: 0 }}
                  fadeOut
                  autoStart
                />
              </View>
              <View>
                <Text style={{ fontWeight: 'semibold' }}>
                  Entdecken Sie über 50 sofort nutzbare Vorlagen für Übungssets.
                  Speichern Sie außerdem Ihre eigenen Sets als Vorlagen und
                  greifen Sie jederzeit wieder darauf zu. Weniger Aufwand - mehr
                  Zeit für Ihre Patient:innen.
                </Text>
              </View>
            </View>
          ),
        });
      } catch (err) {
        logError('Error checking modal flag:', err);
      }
    };

    showIfUnseen();
    // Runs once on mount — mirrors the original one-shot check.
  }, []);

  return null;
};
